import { TextField } from "@mui/material";
import React, { ChangeEvent, useState } from "react";
import InputMask from "react-input-mask";

type Props = {
  onChange: {
    (e: ChangeEvent<any>): void;
    <T_1 = string | ChangeEvent<any>>(field: T_1): T_1 extends ChangeEvent<any>
      ? void
      : (e: string | ChangeEvent<any>) => void;
  };
  id: string;
  type: string;
  required: boolean;
  variant: "standard" | "filled" | "outlined" | undefined;
  value: string | undefined;
};
function unMaskTel(number: string): string {
  let numberUnmasked = number
    .replace("(", "")
    .replace(")", "")
    .replace("-", "")
    .replaceAll(" ", "");
  return numberUnmasked;
}

const FormikTextField = (props: Props) => {
  return (
    <InputMask
      // mask={maskBuilder(props.value!)}
      // mask={(value) => (value?.length >= 6 && value?.[5] === "9" ? "(99) 99999-9999" : "(99) 9999-9999")}
      // mask={mask}
      mask={props.value && props.value[5] === "9" ? "(99) 9 9999-9999" : "(99) 9999-9999"}
      value={props.value}
      // onChange={onChange}
      onChange={props.onChange}
      maskChar=""
    >
      {() => (
        <TextField
          id={props.id}
          type={props.type}
          required={props.required}
          variant={props.variant}
          onChange={props.onChange}
          fullWidth
          placeholder="Telefone"
          sx={{
            marginTop: "10px",
            paddingX: 1,
            MozAnimation: "none",
            WebkitAppearance: "none",
            appearance: "none",
          }}
        />
      )}
    </InputMask>
  );
};

export default FormikTextField;
